module.exports = __webpack_public_path__ + "static/media/neutrosys.9b5404d4.png";